import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { replace, push } from 'connected-react-router';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import ItemDetailActions, { ItemDetailTypes } from '../Stores/ItemDetail/Actions';

const getAppStore = state => state.app;

export function* itemDetailInitModel({ itemType }) {
  try {
    yield put(ItemDetailActions.itemDetailShowModelLoading(true));

    const app = yield select(getAppStore);
    const getData = {};

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `item/initModel/${itemType}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      yield put(ItemDetailActions.itemDetailShowModelSuccess(result.data));
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(ItemDetailActions.itemDetailShowModelLoading(false));
  }
}

export function* itemDetailShowModel({ resId }) {
  try {
    yield put(ItemDetailActions.itemDetailShowModelLoading(true));

    const app = yield select(getAppStore);
    const getData = {};

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `item/showModel/${resId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      yield put(ItemDetailActions.itemDetailShowModelSuccess(result.data));
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(ItemDetailActions.itemDetailShowModelLoading(false));
  }
}

export function* itemDetailUpdateModel({ formikBag, model }) {
  formikBag.setSubmitting(true);
  try {
    const app = yield select(getAppStore);

    const postData = {
      data: model
    };

    const result = yield call(
      ApiService.putApi, // function
      app.apiUrl,
      'item/updateModel',
      app.token,
      postData // params
    );

    if (result.isSuccess === true) {
      const { model: retModel } = result.data;

      yield put(ItemDetailActions.itemDetailUpdateModelSuccess(retModel));
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    formikBag.setSubmitting(false);
  }
}

export function* itemDetailCreateModel({ formikBag, model }) {
  formikBag.setSubmitting(true);
  try {
    const app = yield select(getAppStore);

    const postData = {
      data: model
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `item/createModel`,
      app.token,
      postData // params
    );

    if (result.isSuccess === true) {
      yield put(replace(`${app.appPath}/itemDetail/update/${result.data}/GENERAL`));
      yield put(ItemDetailActions.itemDetailSetResId(result.data));
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    formikBag.setSubmitting(false);
  }
}

export function* itemDetailFetchItemGroup01Options({ search }) {
  try {
    yield put(ItemDetailActions.itemDetailFetchItemGroup01OptionLoading(true));

    const app = yield select(getAppStore);
    const postData = {
      siteFlowId: app.curSiteFlowId,
      search
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `itemGroup01/select2`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      const options = result.data.data.map(d => ({ value: d.id, label: `${d.code}` }));

      yield put(ItemDetailActions.itemDetailFetchItemGroup01OptionSuccess(options));
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(ItemDetailActions.itemDetailFetchItemGroup01OptionLoading(false));
  }
}

export function* itemDetailFetchItemGroup02Options({ search }) {
  try {
    yield put(ItemDetailActions.itemDetailFetchItemGroup02OptionLoading(true));

    const app = yield select(getAppStore);
    const postData = {
      siteFlowId: app.curSiteFlowId,
      search
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `itemGroup02/select2`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      const options = result.data.data.map(d => ({ value: d.id, label: `${d.code}` }));

      yield put(ItemDetailActions.itemDetailFetchItemGroup02OptionSuccess(options));
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(ItemDetailActions.itemDetailFetchItemGroup02OptionLoading(false));
  }
}

export function* itemDetailFetchItemGroup03Options({ search }) {
  try {
    yield put(ItemDetailActions.itemDetailFetchItemGroup03OptionLoading(true));

    const app = yield select(getAppStore);
    const postData = {
      siteFlowId: app.curSiteFlowId,
      search
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `itemGroup03/select2`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      const options = result.data.data.map(d => ({ value: d.id, label: `${d.code}` }));

      yield put(ItemDetailActions.itemDetailFetchItemGroup03OptionSuccess(options));
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(ItemDetailActions.itemDetailFetchItemGroup03OptionLoading(false));
  }
}

export function* itemDetailFetchUomOptions({ search }) {
  try {
    yield put(ItemDetailActions.itemDetailFetchUomOptionLoading(true));

    const app = yield select(getAppStore);
    const postData = {
      search
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `uom/select2`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      let options = [{ value: 0, label: `` }];
      options = options.concat(result.data.data.map(d => ({ value: d.id, label: `${d.code}` })));

      yield put(ItemDetailActions.itemDetailFetchUomOptionSuccess(options));
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(ItemDetailActions.itemDetailFetchUomOptionLoading(false));
  }
}

export function* itemDetailShowItemBatches({ resId, currentPage, sorts, filters, pageSize }) {
  try {
    yield put(ItemDetailActions.itemDetailShowModelLoading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `item/showItemBatches/${resId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        ItemDetailActions.itemDetailShowItemBatchSuccess(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(ItemDetailActions.itemDetailShowModelLoading(false));
  }
}

export function* itemDetailGoToItemBatch({ itemBatchId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/itemBatchDetail/update/${itemBatchId}`));
}

export function* itemDetailGoToAuditItemBatch({ itemBatchId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/auditResource/ITEM_BATCH/${itemBatchId}/ItemBatch`));
}

export function* itemDetailNewItemBatch({ itemId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/itemBatchDetail/create/${itemId}`));
}

export function* itemDetailShowItemDocNo({ itemId }) {
  try {
    yield put(ItemDetailActions.itemDetailShowItemDocNoLoading(true));

    const app = yield select(getAppStore);
    const getData = {};

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `itemDocNo/showModel/${itemId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      yield put(ItemDetailActions.itemDetailShowItemDocNoSuccess(result.data.data));
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(ItemDetailActions.itemDetailShowItemDocNoLoading(false));
  }
}

export function* itemDetailCreateItemDocNo({ formikBag, itemDocNoDtl, resId }) {
  formikBag.setSubmitting(true);
  yield put(ItemDetailActions.itemDetailShowItemDocNoLoading(true));
  try {
    const app = yield select(getAppStore);

    const postData = {
      itemId: resId,
      data: itemDocNoDtl,
      divisionId: app.curDivisionId
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `itemDocNo/createItemDocNo/${resId}`,
      app.token,
      postData // params
    );

    if (result.isSuccess === true) {
      yield put(ItemDetailActions.itemDetailShowItemDocNo(resId));

      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    formikBag.setSubmitting(false);
    yield put(ItemDetailActions.itemDetailShowItemDocNoLoading(false));
  }
}

export function* itemDetailUpdateItemDocNo({ formikBag, itemDocNoDtl, resId }) {
  formikBag.setSubmitting(true);
  yield put(ItemDetailActions.itemDetailShowItemDocNoLoading(true));
  try {
    const app = yield select(getAppStore);

    const postData = {
      data: itemDocNoDtl,
      divisionId: app.curDivisionId
    };

    const result = yield call(
      ApiService.putApi, // function
      app.apiUrl,
      `itemDocNo/updateItemDocNo`,
      app.token,
      postData // params
    );

    if (result.isSuccess === true) {
      yield put(ItemDetailActions.itemDetailShowItemDocNo(resId));

      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    formikBag.setSubmitting(false);
    yield put(ItemDetailActions.itemDetailShowItemDocNoLoading(false));
  }
}

export function* itemDetailDeleteItemDocNo({ itemDocNoDtl, resId }) {
  yield put(ItemDetailActions.itemDetailShowItemDocNoLoading(true));
  try {
    const app = yield select(getAppStore);

    const postData = {
      data: itemDocNoDtl
    };

    const result = yield call(
      ApiService.deleteApi, // function
      app.apiUrl,
      `itemDocNo/deleteItemDocNos`,
      app.token,
      postData // params
    );

    if (result.isSuccess === true) {
      yield put(ItemDetailActions.itemDetailShowItemDocNo(resId));

      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(ItemDetailActions.itemDetailShowItemDocNoLoading(false));
  }
}

export const saga = [
  takeLatest(ItemDetailTypes.ITEM_DETAIL_INIT_MODEL, itemDetailInitModel),
  takeLatest(ItemDetailTypes.ITEM_DETAIL_SHOW_MODEL, itemDetailShowModel),

  takeLatest(ItemDetailTypes.ITEM_DETAIL_UPDATE_MODEL, itemDetailUpdateModel),
  takeLatest(ItemDetailTypes.ITEM_DETAIL_CREATE_MODEL, itemDetailCreateModel),

  takeLatest(
    ItemDetailTypes.ITEM_DETAIL_FETCH_ITEM_GROUP01_OPTIONS,
    itemDetailFetchItemGroup01Options
  ),
  takeLatest(
    ItemDetailTypes.ITEM_DETAIL_FETCH_ITEM_GROUP02_OPTIONS,
    itemDetailFetchItemGroup02Options
  ),
  takeLatest(
    ItemDetailTypes.ITEM_DETAIL_FETCH_ITEM_GROUP03_OPTIONS,
    itemDetailFetchItemGroup03Options
  ),

  takeLatest(ItemDetailTypes.ITEM_DETAIL_FETCH_UOM_OPTIONS, itemDetailFetchUomOptions),

  takeLatest(ItemDetailTypes.ITEM_DETAIL_SHOW_ITEM_BATCHES, itemDetailShowItemBatches),
  takeLatest(ItemDetailTypes.ITEM_DETAIL_GO_TO_ITEM_BATCH, itemDetailGoToItemBatch),
  takeLatest(ItemDetailTypes.ITEM_DETAIL_GO_TO_AUDIT_ITEM_BATCH, itemDetailGoToAuditItemBatch),
  takeLatest(ItemDetailTypes.ITEM_DETAIL_NEW_ITEM_BATCH, itemDetailNewItemBatch),
  takeLatest(ItemDetailTypes.ITEM_DETAIL_SHOW_ITEM_DOC_NO, itemDetailShowItemDocNo),

  takeLatest(ItemDetailTypes.ITEM_DETAIL_CREATE_ITEM_DOC_NO, itemDetailCreateItemDocNo),
  takeLatest(ItemDetailTypes.ITEM_DETAIL_UPDATE_ITEM_DOC_NO, itemDetailUpdateItemDocNo),
  takeLatest(ItemDetailTypes.ITEM_DETAIL_DELETE_ITEM_DOC_NO, itemDetailDeleteItemDocNo)
];
